import { createSelector } from 'reselect';
import { RootState } from '../store';
import { PaginationType } from '@/types';

export const getStorages = createSelector(
  [(state: RootState) => state.storage?.ids, (state: RootState) => state.storageEntities?.ids],
  (ids, entities) => ids?.map((id) => entities[id])
);

export const getStoragePagination = createSelector(
  (state: RootState) => state.storage?.pagination,
  (result): PaginationType => result as PaginationType
);

export const getStorageLoading = createSelector(
  (state: RootState) => state.storage?.loading,
  (result): boolean => result
);
